import React from 'react'
import PropTypes from 'prop-types'
import Icon from '../../../../elementals/icon'
import classnames from 'classnames/bind'
import styles from './index.scss'

const cx = classnames.bind(styles)

const Panel = ({ children, onClose, className, elmId, cls: extcls }) => (
  <div className={cx('root', className)} data-elm-id={elmId}>
    {children}
    <Icon
      name='times'
      size='big'
      iconStyle='regular'
      style={{ color: 'inherit' }}
      data-elm-id={`${elmId}_close_icon`}
      className={cx('close', extcls.close)}
      onClick={onClose}
    />
  </div>
)

Panel.propTypes = {
  cls: PropTypes.shape({
    close: PropTypes.string,
  }),
  className: PropTypes.string,
  elmId: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,
}

Panel.defaultProps = {
  elmId: 'property_gallery_media_panel',
  cls: {
    close: '',
  },
}

const View = ({ children, className, elmId }) => (
  <div className={cx('view', className)} data-elm-id={elmId}>
    {children}
  </div>
)

View.propTypes = {
  elmId: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
}

View.defaultProps = {
  elmId: 'property_gallery_media_panel_view',
}

export default Panel

export { Panel, View }
